import request from '@/utils/http/axios'

const UPLOAD_SCENE = '16'
const goURL = import.meta.env.VITE_GO_API_URL

// 获取城市
export const queryRegion = params => {
  return request.get({ url: `${goURL}/clinic/handler/QueryRegion`, params })
}

// 获取城市
export const queryClinic = params => {
  return request.get({ url: `${goURL}/clinic/h5/QueryClinic`, params })
}

// 上传oss 获取签名
export const getOSSToken = (file_type, contentType = null) => {
  return request.post({
    url: `${goURL}/oss/handler/GenToken`,
    data: { file_type, scene: UPLOAD_SCENE, ...contentType }
  })
}

// 根据分院id获取分院信息
export const queryClinicInfoById = params => {
  return request.get({ url: `${goURL}/clinic/handler/QueryShopDetail`, params })
}

// 语音转文字
export const apiRecordToText = data => {
  return request.post({ url: `${goURL}/alirtc/handler/RecognizeSpeech`, data })
}
